const ENDPOINT = 'https://nakagawa.nkmr.io/api/pensaku/post_log.php';
const uuid = () => (crypto?.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
const SESSION_IDLE_MS = 30 * 60 * 1000; // セッション切れ30分(要変更)

// 端末IDは端末固定 → localStorage
export const deviceId = (() => {
    let v = localStorage.getItem('device_id');
    if (!v) {
        v = uuid();
        localStorage.setItem('device_id', v);
    }
    return v;
})();

// ---- セッションはタブ単位 → sessionStorage ----
function newSession() {
    const sid = uuid();
    sessionStorage.setItem('session_id', sid);
    sessionStorage.setItem('session_last_active', String(Date.now()));
    // session_start を画面側で送るときのフラグは screen 側で持つ（例：session_started_for:<sid>）
    return sid;
}

function ensureSession() {
    const now = Date.now();
    let sid = sessionStorage.getItem('session_id');
    const last = Number(sessionStorage.getItem('session_last_active') || 0);

    if (!sid) sid = newSession();
    else if (last && now - last > SESSION_IDLE_MS) sid = newSession(); // アイドル超過でローテーション（任意）

    sessionStorage.setItem('session_last_active', String(now));
    return sid;
}

// セッション開始時刻を保存しておく
export function markSessionStart() {
    sessionStorage.setItem('session_start_ts', String(Date.now()));
}

export function fireSessionEnd(reason = 'close') {
    const start = Number(sessionStorage.getItem('session_start_ts') || 0);
    const dwell = start ? Date.now() - start : null;

    fire('session_end', {
        reason,
        dwell_ms: dwell ? Math.round(dwell) : null
    });
}

// ---- 送信関数 ----
export function fire(name, payload = {}) {
    const sid = ensureSession();
    const evt = {
        event_id: uuid(),
        session_id: sid,
        name,
        client_ts: Date.now(),
        payload
    };

    fetch(ENDPOINT, {
        method: 'POST',
        mode: 'cors', // ← 必須（コメントアウトしない）
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'omit', // ← Cookie不要なら omit（* と両立しやすい）
        body: JSON.stringify(evt),
        keepalive: true,
    }).catch(() => {
        // 必要なら IndexedDB 退避など
        // console.log(JSON.stringify(evt));
    });

    return evt;
}

// 離脱時まとめ送信（必要なら）
export function beaconBatch(events) {
    try {
        const blob = new Blob([JSON.stringify({
            events
        })], {
            type: 'application/json'
        });
        navigator.sendBeacon(ENDPOINT, blob);
    } catch (_) {
        /* no-op */ }
}

// 画面名マッパ（必要に応じてパスを追加）
export function mapScreenByPath(path = location.pathname) {
    if (path.endsWith('/form')) return 'home';
    if (path.includes('/draw-penguin')) return 'draw';
    if (path.endsWith('/list')) return 'catalog';
    if (path.endsWith('/ranking')) return 'ranking';
    if (path.endsWith('/pen-detail')) return 'detail';
    if (path.endsWith('/collection')) return 'album';
    return 'other';
}

// 直前画面を取得（なければ direct / external を返す）
export function getPrevScreen() {
    const s = sessionStorage.getItem('last_screen');
    if (s) return s;
    // 直アクセスか外部遷移かのざっくり判定
    return document.referrer ? 'external' : 'direct';
}

// 現在画面を保存
export function setCurrentScreen(screen) {
    sessionStorage.setItem('last_screen', screen);
}

// 新しいセッションかどうか（画面側で session_start を送るかどうかの判定用）
export function isNewSession() {
  const sid = sessionStorage.getItem('session_id');
  const lastStart = sessionStorage.getItem('session_start_ts');
  // 新しい session_id なら true
  return !lastStart || !sid || !sessionStorage.getItem('sent_session_start_for_' + sid);
}





// function getOrCreate(key, make) {
//     let v = localStorage.getItem(key);
//     if (!v) {
//         v = make();
//         localStorage.setItem(key, v);
//     }
//     return v;
// }

// // 端末ID & セッションID（初回だけ発行して保持）
// export const deviceId = getOrCreate('device_id', uuid);
// export const sessionId = getOrCreate('session_id', uuid);

// // 単発イベント送信（即時・awaitしない・UIを止めない）
// export function fire(name, payload = {}) {
//     const evt = {
//         event_id: uuid(),
//         session_id: sessionId,
//         name,
//         client_ts: Date.now(),
//         payload
//     };

//     // 非同期で撃って忘れる（失敗してもUIは継続）
//     fetch(ENDPOINT, {
//         method: 'POST',
//         mode: 'cors',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         // 同一オリジンなら不要／別オリジンかつCookie必要なら 'include'
//         credentials: 'same-origin',
//         body: JSON.stringify(evt),
//         keepalive: true, // 離脱時でも送られやすい
//     }).catch(() => {
//         console.log(JSON.stringify(evt))
//         /* 必要ならここでIndexedDB退避など */
//     });

//     // search_idに使いたい等の用途向けに返す
//     return evt;
// }

// // ページ離脱時のflush（必要に応じて呼ぶ）
// export function beaconBatch(events) {
//     try {
//         const blob = new Blob([JSON.stringify({
//             events
//         })], {
//             type: 'application/json'
//         });
//         navigator.sendBeacon(ENDPOINT, blob);
//     } catch (_) {
//         /* no-op */
//     }
// }